import { escapeRegExp } from '@/utils/escapeRegExp';

const { get, post, patch, put } = require('utils/request');

export function* searchThroughDatabase(searchString: string, url: string, searchField: string) {
  const params = {
    filter: {
      limit: 50,
      where: {
        [searchField]: {
          regexp: `/^${escapeRegExp(searchString.toLowerCase())}/i`,
        },
      },
    },
  };

  const items = yield get({ url, params });

  return items;
}

export function* fetchInitialValue(id: string, url: string) {
  const value = yield get(`${url}/${id}`);
  return value;
}

export function* fetchInitialValues(ids: string[], url: string) {
  const values = yield get({ url, params: { filter: { where: { id: { inq: ids } } } } });
  return values;
}

export function* fetchPreload(preload: any, url: string) {
  const params = {
    filter: {
      limit: 50,
      where: preload,
    },
  };

  const items = yield get({ url, params });

  return items;
}
